import { useEffect, useMemo, useRef } from "react";
import { useSelectedBusiness } from "../../redux/store";
import { useAuthStatus } from "../../util/useAuthStatus";
import { BusinessQueryNames } from "../../graphql/queries";
import useLoadReduxStoreData from "../../redux/reducers/loadReduxStoreData";
// ⬅️ adjust to your actual file name/path 
export default function useBusinessFromStore(options = {}) {
  const { autoHydrate = true } = options;
  const selected = useSelectedBusiness();
  const business = selected || null;

  const businessId = useMemo(() => {
    const raw = business?.businessBasic?.id  
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  }, [business]);

  const { isLoggedIn } = useAuthStatus();
  const { refetch: reloadBusinesses, loading: loadingMyBusinesses } =
    useLoadReduxStoreData(BusinessQueryNames.GET_MY_BUSINESSES, {
      enabled: isLoggedIn && autoHydrate,
    }); 
  
  const triedOnce = useRef(false);
  useEffect(() => {
    if (!autoHydrate) return;
    if (!isLoggedIn) return;
    if (businessId) return;
    if (triedOnce.current) return;
    triedOnce.current = true;
    reloadBusinesses?.();
  }, [autoHydrate, isLoggedIn, businessId, reloadBusinesses]);

  return { // This is where the correction was needed
    business,
    businessId,
    ready: Boolean(businessId),
    loading: loadingMyBusinesses,
    reload: reloadBusinesses,
  };
}